module.exports = __webpack_public_path__ + "static/site-85278fffb8eae95f074f7b919fc0110f.jpg";